import { useState } from "react"
import Screen from "src/shared/components/layout/screen/Screen"
import { Search } from "./components/Search"
import "./index.css"
import GastosList from "./components/gastos-list/GastosList"
import { useNavigate } from "react-router-dom"
import { Option } from "src/shared/components/forms/selelct-dropdown/Dropdown"
import { useTotal_Gastos_Por_Dia_RecepcionistaQuery } from "src/gql/schema"
import { useCurrentRol } from "src/shared/widgets/hooks/general"
import { formatCurrency } from "src/shared/hooks/formatCurrency"
import useEscapeKey from "src/shared/hooks/useEscapeKey"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "src/store/store"
import { toggleNuevoGastoModalOpen } from "src/store/gastos/gastosSlice"
import { RoleNames } from "src/shared/hooks/useAuth"
import CategoriasGastoSelect, { TODOS_CATEGORIA_FILTER } from "./components/CategoriasGastoSelect/CategoriasGastoSelect"
import { ButtonIcon } from "src/shared/components/forms/button-icon/ButtonIcon"
import { useFormatDate } from "src/shared/hooks/useFormatDate"
import { useProfile } from "src/shared/hooks/useProfile"
import { CalendarButtons } from "src/shared/components/navigation/CalendarButtons/CalendarButtons"

const options: Option[] = [
    { label: "Enero", value: "0" },
    { label: "Febrero", value: "1" },
    { label: "Marzo", value: "2" },
    { label: "Abril", value: "3" },
    { label: "Mayo", value: "4" },
    { label: "Junio", value: "5" },
    { label: "Julio", value: "6" },
    { label: "Agosto", value: "7" },
    { label: "Septiembre", value: "8" },
    { label: "Octubre", value: "9" },
    { label: "Noviembre", value: "10" },
    { label: "Diciembre", value: "11" },
]

function Gastos() {
    const { nowHotel } = useFormatDate()

    const { isNuevoGastoModalOpen } = useSelector((state: RootState) => state.gastos)
    const dispatch = useDispatch()

    const navigate = useNavigate()
    const [search, setSearch] = useState("")
    const [date, setDate] = useState(nowHotel.getMonth())
    const [year, setYear] = useState(nowHotel.getFullYear())
    const [categoryIdSelected, setcategoryIdSelected] = useState<{ name: string, id: string }>(TODOS_CATEGORIA_FILTER)

    const rol = useCurrentRol()
    const { hotel_id } = useProfile()

    const { data: gastosDelMesRecepcionista, refetch: refetchTotalRecepcion } =
        useTotal_Gastos_Por_Dia_RecepcionistaQuery({
            variables: {
                category_id: categoryIdSelected.id || null,
                hotel_id
            },
            skip: rol !== RoleNames.recepcionista
        })

    useEscapeKey({
        onEscape: () => {
            if (isNuevoGastoModalOpen) {
                return dispatch(toggleNuevoGastoModalOpen(false))
            }
            navigate("/u")
        },
    })

    return (
        <Screen
            title={`Gastos - ${categoryIdSelected?.name || ""}`}
            contentClassName="gastos-screen"
            close
            onClose={() => navigate("/u")}
            headerRight={
                <>
                    {
                        rol === RoleNames.recepcionista && (
                            <CategoriasGastoSelect value={categoryIdSelected} onSelect={(v) => {
                                setcategoryIdSelected(v)
                                setSearch("")
                            }}
                            />
                        )
                    }
                    {([RoleNames.admin, RoleNames.superadmin, RoleNames.gerente].includes(rol)) && (
                        <div
                            className={
                                // "gastos-screen-right"
                                "gastos-screen-right-empty"
                            }
                            style={{ display: "flex", columnGap: "10px" }}
                        >
                            <Search value={search} onChange={(value) => setSearch(value)} onClear={() => setSearch("")} />
                            <CalendarButtons
                                className="gastos-screen-header-controls"
                                currMonth={date}
                                setCurrMonth={(v) => {
                                    if(v === 11 && date === 0) {
                                        setYear(y => y - 1)
                                    }
                                    if(v === 0 && date === 11 && year < nowHotel.getFullYear()) {
                                        setYear(y => y + 1)
                                    }
                                    setDate(v)
                                }}
                                currYear={year}
                                setCurrYear={setYear}
                                monthNames={options.map(({ label }) => label)}
                            />
                            <CategoriasGastoSelect value={categoryIdSelected} onSelect={(v) => {
                                setcategoryIdSelected(v)
                                setSearch("")
                            }}
                            />

                            <ButtonIcon iconName="Gear" iconProps={{ width: 20, height: 20 }}
                                onClick={() => navigate("/u/gastos/config")}
                            />
                        </div>
                    )}
                </>
            }
        >
            {[RoleNames.recepcionista].includes(rol) ? (
                <div className="gastos-search">
                    <p className="gastos-search-title">
                        Gastos de caja del día:{" "}
                        {formatCurrency(
                            gastosDelMesRecepcionista?.total_gastos_por_dia_recepcionista?.total_gasto || 0
                        )}
                    </p>
                    <div className="gastos-search-inputs">
                        <Search onChange={(value) => setSearch(value)} onClear={() => setSearch("")} />
                    </div>
                </div>
            ) : null}

            <GastosList
                categoryName={categoryIdSelected.name || ""}
                categoryId={categoryIdSelected?.id || ""}
                search={search}
                date={`${date}`}
                year={`${year}`}
                reload={refetchTotalRecepcion}
            />
        </Screen>
    )
}

export default Gastos
